import { parseError } from 'utils/utils';
import apiService from 'services/apiService';
import DistrictGradebook from 'models/analytics/DistrictGradebook';
import User from 'models/User';
import { UserMetadata } from 'models/analytics/UserMetadata';
import EvaluationSubmission from 'models/EvaluationSubmission';

export type DistrictStudent = {
  user: User;
  metadata: UserMetadata;
  evaluations: EvaluationSubmission[];
};

export class DistrictAdminService {
  private static instance: DistrictAdminService;

  public static get(): DistrictAdminService {
    if (!DistrictAdminService.instance) {
      DistrictAdminService.instance = new DistrictAdminService();
    }

    return DistrictAdminService.instance;
  }

  getGradebook = async (districtId: string): Promise<DistrictGradebook> => {
    try {
      const response = await apiService.api.get(
        `/districts/${districtId}/gradebook/`,
      );
      return DistrictGradebook.fromServerDistrictGradebook(response.data);
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };

  getStudents = async (districtId: string): Promise<DistrictStudent> => {
    try {
      const response = await apiService.api.get(
        `/districts/${districtId}/students/`,
      );
      return response.data.map((districtUser: Record<string, any>) => ({
        user: User.fromServerUser(districtUser.user),
        metadata: districtUser.metadata,
        evaluations: districtUser.evaluations,
      }));
    } catch (error) {
      console.error(error);
      return Promise.reject(new Error(parseError(error)));
    }
  };
}

export const districtAdminService = DistrictAdminService.get();
